/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiMarker } from '../../models/api-marker';

export interface ApiSystemHistoryMarkersGet$Params {
}

export function apiSystemHistoryMarkersGet(http: HttpClient, rootUrl: string, params?: ApiSystemHistoryMarkersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiMarker>>> {
  const rb = new RequestBuilder(rootUrl, apiSystemHistoryMarkersGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApiMarker>>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
apiSystemHistoryMarkersGet.PATH = '/api/SystemHistory/markers';
apiSystemHistoryMarkersGet.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
apiSystemHistoryMarkersGet.ROOTURL = '/tube';
